module.exports = __webpack_public_path__ + "static/media/valentina_guerrero_marin_5.8e4c0ac2.gif";